import gql from 'graphql-tag'

export const fetchSuggestedCartQuery = gql`

query (
  $sku: [String]
  $search: String
  $sort: ProductAttributeSortInput
  $brand: [String]
  $category_uid: [String]
  $pack_format: [String]
  $volume: [String]
  $ship_tos: [String]
) {
  getSuggestedCarts(
    search: $search,
    ship_tos: $ship_tos
    filter: {
      sku: { in: $sku }
      brand: { in: $brand }
      pack_format: { in: $pack_format }
      category_uid: { in: $category_uid }
      volume: { in: $volume }
    }
    sort: $sort
  ) {
    categoryFilter {
      category_name
      category_id
      category_uid
    }
    items {
      suggested_cart_total
      shipping_address {
        outlet_name
        street
        city
        postalcode
        sap_id
      }
      products {
        sku
        packaging_enable
        material_type
        image
        name
        number_of_items_on_pallet
        number_of_items_on_layer
        number_of_layers_per_pallet
        total_units
        number_of_layers
        number_of_pallets
        price_per_piece
        your_price_wo_vat
        tags {
          value
          label
          color
        }
      }
    }
    aggregations {
      attribute_code
      label
      options {
        label
        value
      }
    }
  }
}
`
